import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';

export interface Message {
  text?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private subject = new Subject<Message>();

  sendMessage(message: string) {
    this.subject.next({ text: message });
  }

  clearMessages() {
    this.subject.next({});
  }

  getMessage(): Observable<Message> {
    return this.subject.asObservable();
  }
}
